import React, {Component} from 'react';
import Layout from "../../Component/Layout/Layout";

class Categories extends Component {
    render() {
        return (
            <div>
                <Layout/>

               <div className="content">
                 <p>,mnbvcx</p>
               </div>
            </div>
        );
    }
}

export default Categories;
